import { useState } from "react";
import { useTenantQuery } from "../hooks/useTenantData";
import { ROLE_LABELS, type AuditEvent } from "../api/types";
import { PageHeader, Panel, QueryState } from "../components/ui";

export function AuditPage() {
  const [action, setAction] = useState("");
  const [entityType, setEntityType] = useState("");
  const events = useTenantQuery(["audit-events", { action, entityType }], (api, t) =>
    api.listAuditEvents(t, {
      action: action || undefined,
      entity_type: entityType || undefined,
    }),
  );

  return (
    <>
      <PageHeader
        title="Auditoria"
        subtitle="Registro somente leitura das alterações administrativas deste condomínio."
      />
      <Panel title="Eventos">
        <div className="toolbar">
          <label>
            Ação
            <input
              type="search"
              value={action}
              onChange={(e) => setAction(e.target.value)}
              placeholder="ex.: invitation, unit.updated"
            />
          </label>
          <label>
            Entidade
            <select value={entityType} onChange={(e) => setEntityType(e.target.value)}>
              <option value="">Todas</option>
              <option value="tenant_profile">Perfil</option>
              <option value="admin_user">Usuário administrativo</option>
              <option value="block">Bloco</option>
              <option value="unit">Unidade</option>
              <option value="person">Pessoa</option>
              <option value="occupancy">Ocupação</option>
              <option value="invitation">Convite</option>
              <option value="device">Dispositivo</option>
              <option value="import">Importação</option>
              <option value="tenant">Condomínio</option>
            </select>
          </label>
        </div>
        <QueryState query={events} empty="Nenhum evento de auditoria com os filtros atuais.">
          {(items) => (
            <div className="table">
              {items.map((event) => (
                <div className="table-row" key={event.id}>
                  <span>
                    <strong>{event.action}</strong>
                    <small>
                      {event.entity_type}
                      {event.entity_label ? ` · ${event.entity_label}` : ""}
                    </small>
                  </span>
                  <span>
                    {event.actor_name}
                    <small>{actorRoleLabel(event)}</small>
                  </span>
                  <time dateTime={event.created_at}>
                    {new Date(event.created_at).toLocaleString("pt-BR")}
                  </time>
                </div>
              ))}
            </div>
          )}
        </QueryState>
      </Panel>
    </>
  );
}

function actorRoleLabel(event: AuditEvent): string {
  if (event.actor_role === "platform") return "Equipe AVA";
  return ROLE_LABELS[event.actor_role];
}
